export const careerPath = [
  {
    level: 'Specialist',
    title: 'Deepening expertise',
    support: 'We help specialists find roles that reward rare expertise, and position that expertise clearly for hiring managers.',
  },
  {
    level: 'Senior Manager',
    title: 'Leading teams and functions',
    support: 'We explore the scope, team and leadership culture of each opportunity so your next step builds genuine capability.',
  },
  {
    level: 'Executive',
    title: 'Owning strategy and results',
    support: 'Confidential conversations about timing, positioning and the leadership story behind your achievements.',
  },
  {
    level: 'C-Suite',
    title: 'Shaping the enterprise',
    support: 'Discreet guidance through complex, board-led processes, stakeholder interviews and offer negotiation.',
  },
  {
    level: 'Board',
    title: 'Governing and advising',
    support: 'Help articulating your board-level contribution and preparing for nomination committee conversations.',
  },
];
